export default "__VITE_PUBLIC_ASSET__ac763a33__"